import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBelarus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_271)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#FCFCFC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.9565 11.1304L3.65216 8.76403L4.9565 6.43477L6.26085 8.76403L4.9565 11.1304Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.3478 11.1304L1.04346 8.76403L2.3478 6.43477L3.65214 8.76403L2.3478 11.1304Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.9565 17.5652L3.65216 15.1988L4.9565 12.8696L6.26085 15.1988L4.9565 17.5652Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.3478 17.5652L1.04346 15.1988L2.3478 12.8696L3.65214 15.1988L2.3478 17.5652Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26083 2.32931L5.89155 1.66988C5.22921 2.06231 4.60797 2.51667 4.03558 3.02499L4.95649 4.69566L6.26083 2.32931Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.95647 19.3044L4.02582 20.9664C4.59769 21.4753 5.21851 21.9304 5.88057 22.3236L6.26086 21.6337L4.95647 19.3044Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.30432 15.1305V23.0459C8.74662 23.6598 10.3335 24 12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739L7.30432 15.1305Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2536 16.1739C23.736 14.8739 24 13.4678 24 12C24 5.37263 18.6274 0 12 0C10.3336 0 8.74662 0.339984 7.30432 0.953813V16.1739H23.2536V16.1739Z",
				fill: "#A2001D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_271",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBelarus;
